export default {
	"planMapComp": {
		"showLocal": "แสดงสถานที่สำคัญ",
		"multipleSelectionAddress": "กรุณาระบุตำแหน่งรายการที่อยู่ดังต่อไปนี้ด้วยตนเอง",
		"defectAddressGps": "ไม่มีพิกัดที่อยู่",
		"supplement": "เพิ่มเติม",
		"timeWindows": "กรอบเวลา",
		"allDay": "ทั้งวัน",
		"huoliang": "ปริมาตร",
		"dan": "คำสั่ง",
		"gong": "รวมทั้งหมด",
		"errMsg": "สาเหตุของความล้มเหลวของแผน ได้แก่",
		"start": "เพิ่มขึ้น",
		"more": "มากมาย",
		"jihua": "วางแผน",
		"daoda": "มาถึง",
		"likai": "ออกจาก",
		"xinxiDialog": "กรอบข้อมูล",
		"xiuzheng": "แก้ไขการกำหนดตำแหน่ง",
		"peisong": "การจัดส่ง",
		"dian": "สถานที่",
		"btnCreateRoute": "สร้างรายการจัดส่ง",
		"aiPaixian": "การวางแผนเส้นทางอัจฉริยะ",
		"selectRouterTips": "กรุณาเลือกใบตราส่งสินค้า",
		"rangeValueTips1": "ระยะทางต้องเป็นบวก",
		"rangeValueTips2": "สามารถกรอกระยะทางเป็นตัวเลขเท่านั้น",
		"noTransports": "ไม่มีการทดลองคำนวณสายยานพาหนะ",
		"none": "ไม่มี"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/planMapComp/planMapComp.js